import './Hero.css';
import heroBackground from '../../assets/images/fundo3.png';

function Hero() {
  return (
    <section id="home" className="hero">
      <img src={heroBackground} alt="Hero Background" className="hero-image" />
      <div className="hero-overlay"></div>
    </section>
  );
}

export default Hero;
